<template>
    <div>
        <div class="mb-3">
            <div class="d-inline-block h3 mb-0 align-middle">Заявка <span class="text-primary">№ {{id}}</span></div>
            <template v-if="request && !loading">
                <div v-if="request.doubles && request.doubles.length" class="dropdown d-inline-block align-middle">
                    <a class="btn" href="#" role="button" id="dropdownDouples" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        Дублей <span class="badge badge-danger">{{request.doubles.length}}</span>
                    </a>

                    <div class="dropdown-menu" aria-labelledby="dropdownDouples">
                        <template v-for="double in request.doubles">
                            <router-link :to="{ name: 'request', params: {id: double.id} }" class="dropdown-item">{{double.id}}</router-link>
                        </template>
                    </div>
                </div>
                <router-link v-if="request.parent_id" :to="{ name: 'request', params: {id: request.parent_id} }" class="btn btn-danger align-middle ml-2">Дубль</router-link>
                <button v-if="$hasPermission('requests.create')" @click="modal_request_clone_visible = true" class="btn btn-primary align-middle ml-2"><i class="fas fa-copy mr-1"></i>Клонировать</button>
            </template>
        </div>
        <ModalRequestClone v-if="request && modal_request_clone_visible" :visibleModalRequestClone.sync="modal_request_clone_visible" :request="request"/>
        <RequestLoader v-if="!request || loading"></RequestLoader>
        <div class="row" v-if="request && !loading">
            <div class="col-xl-6 px-3 pr-xl-2">
                <div class="tab mb-0">
                    <ul class="nav nav-tabs" role="tablist">
                        <li class="nav-item"><a class="nav-link active" :href="'#request-tab-1-' + _uid" data-toggle="tab" role="tab">Основное</a></li>
                        <li class="nav-item"><a class="nav-link" :href="'#request-tab-2-' + _uid" data-toggle="tab" role="tab" v-if="$hasPermission('requests.logs.show')">История</a></li>
                        <li class="nav-item"><a class="nav-link" :href="'#request-tab-3-' + _uid" data-toggle="tab" role="tab" v-if="$hasPermission('requests.profiles.show')">Анкета</a></li>
                    </ul>
                </div>
                <div class="tab-content">
                    <div class="tab-pane fade show active" :id="'request-tab-1-' + _uid" role="tabpanel">
                        <div class="card mb-3">
                            <div class="card-body">
                                <div class="form-row">
                                    <div class="form-group col-sm-6 col-xl-4">
                                        <label class="mb-1" for="status">Статус</label>
                                        <el-cascader class="w-100"
                                                     v-model="status_composite"
                                                     :options="status_composite_select"
                                                     :props="{ expandTrigger: 'hover' }"
                                                     separator="  >  "
                                                     size="small"
                                                     :filterable="true"
                                                     @change="handleChangeStatusComposite">
                                            <template slot-scope="{ node, data }">
                                                <span :class="{'font-weight-bold': data.value === null}">{{ data.label }}</span>
                                            </template>
                                        </el-cascader>
                                        <has-error :form="form" field="status"/>
                                    </div>
                                    <div class="form-group col-sm-6 col-xl-4">
                                        <label class="mb-1" for="credit_status">Кредитный Статус</label>
                                        <Select2 v-model="credit_status" :options="credit_statuses_select" :id="'credit_status'" :settings="{width: '100%'}" :class="{ 'has-error': form.errors.has('credit_status') }" @change="validateForm" :disabled="!$hasPermission('requests.change_credit_status')"/>
                                        <has-error :form="form" field="credit_status"/>
                                    </div>
                                    <div class="form-group col-sm-6 col-xl-4">
                                        <div class="custom-controls-stacked ml-3">
                                            <label class="custom-control custom-radio custom-control-inline mb-2">
                                                <input :name="'type' + _uid" type="radio" class="custom-control-input" value="credit" v-model="type" :class="{ 'is-invalid': form.errors.has('type') }" @change="validateForm">
                                                <span class="custom-control-label">Кредит</span>
                                            </label>
                                            <label class="custom-control custom-radio custom-control-inline">
                                                <input :name="'type' + _uid" type="radio" class="custom-control-input" value="cash" v-model="type" :class="{ 'is-invalid': form.errors.has('type') }" @change="validateForm">
                                                <span class="custom-control-label">Наличные</span>
                                            </label>
                                        </div>
                                        <div class="custom-control custom-switch ml-3">
                                            <input type="checkbox" class="custom-control-input" id="in_credit_department" v-model="in_credit_department" :class="{ 'is-invalid': form.errors.has('in_credit_department') }" :disabled="!$hasRole('sales_manager') && !$hasRole('admin')" @change="validateForm">
                                            <label class="custom-control-label" for="in_credit_department">В кредитном</label>
                                        </div>
                                    </div>
                                    <div class="form-group col-sm-6 col-xl-4">
                                        <label class="mb-1" for="operator_id">Оператор <button :disabled="!!request.parent_id || to_work_loading" @click="getToWork" v-show="!operator_id" class="btn btn-primary btn-sm py-0 border-0" v-if="$hasRole('operator')">Взять в работу</button></label>
                                        <Select2 v-model="operator_id" :options="operators_select" :id="'operator_id'" :settings="{width: '100%'}" :disabled="!$hasPermission('requests.change_operator')" />
                                        <has-error :form="form" field="operator_id"/>
                                    </div>
                                    <div class="form-group col-sm-6 col-xl-4">
                                        <label class="mb-1" for="sales_manager_id">Менеджер</label>
                                        <Select2 v-model="sales_manager_id" :options="sales_managers_select" :id="'sales_manager_id'" :settings="{width: '100%'}" :disabled="!$hasPermission('requests.change_sales_manager')" />
                                        <has-error :form="form" field="sales_manager_id"/>
                                    </div>
                                    <div class="form-group col-sm-6 col-xl-4">
                                        <label class="mb-1" for="credit_manager_id">Кредитный спец</label>
                                        <Select2 v-model="credit_manager_id" :options="credit_managers_select" :id="'credit_manager_id'" :settings="{width: '100%'}" :disabled="!$hasPermission('requests.change_credit_manager')" />
                                        <has-error :form="form" field="credit_manager_id"/>
                                    </div>
                                    <div v-if="request && !$hasRole('credit_manager')" class="form-group col-sm-4 col-xl-4">
                                        <div class="text-muted">Создана: </div>
                                        <div class="">{{request.created_at}}</div>
                                    </div>
                                    <div v-if="request && !$hasRole('credit_manager')" class="form-group col-sm-4 col-xl-4">
                                        <div class="text-muted">Площадка: </div>
                                        <div class="">{{request.platform.name}}</div>
                                    </div>
                                    <div v-if="request && !$hasRole('credit_manager')" class="form-group col-sm-4 col-xl-4">
                                        <div class="text-muted">Источник: </div>
                                        <div class="">{{request.source.name}}</div>
                                    </div>
                                    <div class="form-group col-sm-6 col-xl-4">
                                        <label class="mb-1" for="call_date">Дата звонка</label>
                                        <div class="form-row">
                                            <div class="col-8">
                                                <input type="date" :class="{ 'is-invalid': form.errors.has('call_date') }" class="form-control" id="call_date" v-model="call_d" @focusout="validateForm" @change="validateForm">
                                            </div>
                                            <div class="col-4">
                                                <input type="time" :class="{ 'is-invalid': form.errors.has('call_date') }" class="form-control" id="call_time" v-model="call_t" @focusout="validateForm" @change="validateForm">
                                            </div>
                                        </div>
                                        <has-error :form="form" field="call_date"/>
                                    </div>
                                    <div class="form-group col-sm-6 col-xl-4">
                                        <el-tooltip content="Дата и время предполагаемого визита со слов клиента." placement="top-start"><label class="mb-1" for="visit_date">Предполагаемый визит</label></el-tooltip>
                                        <div class="form-row">
                                            <div class="col-8">
                                                <input type="date" :class="{ 'is-invalid': form.errors.has('visit_date') }" class="form-control" id="visit_date" v-model="visit_d" @focusout="validateForm" @change="validateForm">
                                            </div>
                                            <div class="col-4">
                                                <input type="time" :class="{ 'is-invalid': form.errors.has('visit_date') }" class="form-control" id="visit_time" v-model="visit_t" @focusout="validateForm" @change="validateForm">
                                            </div>
                                        </div>
                                        <has-error :form="form" field="visit_date"/>
                                    </div>
                                    <div class="form-group col-sm-6 col-xl-2">
                                        <label class="mb-1" for="discount">Скидка</label>
                                        <input type="number" max="1000000" :class="{ 'is-invalid': form.errors.has('discount') }" class="form-control" id="discount" v-model="discount">
                                        <has-error :form="form" field="discount"/>
                                    </div>
                                    <div class="form-group col-sm-6 col-xl-2">
                                        <div class="custom-control custom-switch ml-3">
                                            <input type="checkbox" class="custom-control-input" :id="'is_spam' + _uid" v-model="is_spam" :class="{ 'is-invalid': form.errors.has('is_spam') }" :disabled="!request.is_spam" @change="validateForm">
                                            <label class="custom-control-label" :for="'is_spam' + _uid">СПАМ</label>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-row">
                                    <div class="form-group mb-0 col-sm-4 col-xl-4" :class="{'text-muted': !visited_at}">
                                        <div><el-tooltip content="Фактический визит на площадку. Дата и время когда клиент вошел на площадку и менеджер взял в работу заявку." placement="top-start"><span>Факт. визит</span></el-tooltip></div>
                                        <div>{{visited_at ? visited_at : '—'}}</div>
                                    </div>
                                    <div class="form-group mb-0 col-sm-4 col-xl-4" :class="{'text-muted': !in_credit_department_datetime}">
                                        <div><el-tooltip content="Отправлен в кредитный отдел. Дата и время когда менеджер отправляет клиента в КО и проставляет флаг 'В кредитном'." placement="top-start"><span>Отправлен в КО</span></el-tooltip></div>
                                        <div>{{in_credit_department_datetime ? in_credit_department_datetime : '—'}}</div>
                                    </div>
                                    <div class="form-group mb-0 col-sm-4 col-xl-4" :class="{'text-muted': !visited_credit_department_at}">
                                        <div><el-tooltip content="Сел в кредитный отдел. Дата и время когда клиент пришел в КО и менеджер КО взял в работу заявку." placement="top-start"><span>Сел в КО</span></el-tooltip></div>
                                        <div>{{visited_credit_department_at ? visited_credit_department_at : '—'}}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="d-flex mb-3 justify-content-end" v-if="$hasPermission('requests.edit') && !request.parent_id && !isNeedTakeToWorkForSave">
                            <button :disabled="form.busy" class="btn btn-primary position-relative" @click="save">Сохранить <span class="hotkey">CTRL + S</span></button>
                            <button :disabled="form.busy" class="btn btn-gray-400 text-dark ml-2 position-relative" @click="saveAndBack">Сохранить и закрыть <span class="hotkey">CTRL + SHIFT + S</span></button>
                        </div>
                        <div class="card">
                            <div class="card-header">
                                <h5 class="card-title mb-0">Контактная информация</h5>
                            </div>
                            <div class="card-body pt-1">
                                <div class="form-row">
                                    <div class="form-group col-sm-4 col-xl-4">
                                        <label class="mb-1" for="last_name">Фамилия</label>
                                        <input type="text" class="form-control" id="last_name" v-model="last_name" :class="{ 'is-invalid': form.errors.has('last_name') }">
                                        <has-error :form="form" field="last_name"/>
                                    </div>
                                    <div class="form-group col-sm-4 col-xl-4">
                                        <label class="mb-1" for="first_name">Имя</label>
                                        <input type="text" class="form-control" id="first_name" v-model="first_name" :class="{ 'is-invalid': form.errors.has('first_name') }" @focusout="validateForm">
                                        <has-error :form="form" field="first_name"/>
                                    </div>
                                    <div class="form-group col-sm-4 col-xl-4">
                                        <label class="mb-1" for="middle_name">Отчество</label>
                                        <input type="text" class="form-control" id="middle_name" v-model="middle_name" :class="{ 'is-invalid': form.errors.has('middle_name') }">
                                        <has-error :form="form" field="middle_name"/>
                                    </div>
                                </div>
                                <div class="form-row">
                                    <div class="form-group col-sm-4 col-xl-4">
                                        <label class="mb-1" for="phone2">Телефон</label>
                                        <a v-if="phone && !visibility_phones['phone'] && $hasPermission('request.phone.show_full')" class="click-to-show" @click="challengeShowPhone('phone')"><i class="far fa-eye"></i></a>
                                        <a v-if="phone && visibility_phones['phone'] && ($hasPermission('request.phone.show_full') || $hasPermission('request.phone.show_full.without_challenge'))" class="copy-to-clipboard" @click="$copyToClipboard(phone.slice(2))"><i class="far fa-clone"></i></a>
                                        <a :href="'https://wa.me/' + phone.slice(1)" target="_blank" v-if="phone && visibility_phones['phone'] && ($hasPermission('request.phone.show_full') || $hasPermission('request.phone.show_full.without_challenge')) && showWhatsapp"><i class="fab fa-whatsapp text-success"></i></a>
                                        <PhoneField v-model="phone" :allow_editing="false" :hide_part_phone="!visibility_phones['phone']" @call="makeCall(phone)" :allow_call="!request.parent_id" :use_validate="false" />
                                    </div>
                                    <div class="form-group col-sm-4 col-xl-4">
                                        <label class="mb-1" for="phone2">Телефон 2</label>
                                        <a v-if="phone2 && !visibility_phones['phone2'] && $hasPermission('request.phone.show_full')" class="click-to-show" @click="challengeShowPhone('phone2')"><i class="far fa-eye"></i></a>
                                        <a v-if="phone2 && visibility_phones['phone2'] && ($hasPermission('request.phone.show_full') || $hasPermission('request.phone.show_full.without_challenge'))" class="copy-to-clipboard" @click="$copyToClipboard(phone2.slice(2))"><i class="far fa-clone"></i></a>
                                        <a :href="'https://wa.me/' + phone2.slice(1)" target="_blank" v-if="phone2 && visibility_phones['phone2'] && ($hasPermission('request.phone.show_full') || $hasPermission('request.phone.show_full.without_challenge')) && showWhatsapp"><i class="fab fa-whatsapp text-success"></i></a>
                                        <PhoneField v-model="phone2" :allow_editing="true" :hide_part_phone="!visibility_phones['phone2']" @call="makeCall(phone2)" :allow_call="!request.parent_id" />
                                    </div>
                                    <div class="form-group col-sm-4 col-xl-4">
                                        <label class="mb-1" for="phone2">Телефон 3</label>
                                        <a v-if="phone3 && !visibility_phones['phone3'] && $hasPermission('request.phone.show_full')" class="click-to-show" @click="challengeShowPhone('phone3')"><i class="far fa-eye"></i></a>
                                        <a v-if="phone3 && visibility_phones['phone3'] && ($hasPermission('request.phone.show_full') || $hasPermission('request.phone.show_full.without_challenge'))" class="copy-to-clipboard" @click="$copyToClipboard(phone3.slice(2))"><i class="far fa-clone"></i></a>
                                        <a :href="'https://wa.me/' + phone3.slice(1)" target="_blank" v-if="phone3 && visibility_phones['phone3'] && ($hasPermission('request.phone.show_full') || $hasPermission('request.phone.show_full.without_challenge')) && showWhatsapp"><i class="fab fa-whatsapp text-success"></i></a>
                                        <PhoneField v-model="phone3" :allow_editing="true" :hide_part_phone="!visibility_phones['phone3']" @call="makeCall(phone3)" :allow_call="!request.parent_id" />
                                    </div>
                                    <div class="form-group col-sm-4 col-xl-4">
                                        <label class="mb-1" for="phone2">Телефон 4</label>
                                        <a v-if="phone4 && !visibility_phones['phone4'] && $hasPermission('request.phone.show_full')" class="click-to-show" @click="challengeShowPhone('phone4')"><i class="far fa-eye"></i></a>
                                        <a v-if="phone4 && visibility_phones['phone4'] && ($hasPermission('request.phone.show_full') || $hasPermission('request.phone.show_full.without_challenge'))" class="copy-to-clipboard" @click="$copyToClipboard(phone4.slice(2))"><i class="far fa-clone"></i></a>
                                        <a :href="'https://wa.me/' + phone4.slice(1)" target="_blank" v-if="phone4 && visibility_phones['phone4'] && ($hasPermission('request.phone.show_full') || $hasPermission('request.phone.show_full.without_challenge')) && showWhatsapp"><i class="fab fa-whatsapp text-success"></i></a>
                                        <PhoneField v-model="phone4" :allow_editing="true" :hide_part_phone="!visibility_phones['phone4']" @call="makeCall(phone4)" :allow_call="!request.parent_id" />
                                    </div>
                                    <div class="form-group col-sm-4 col-xl-4">
                                        <label class="mb-1" for="phone2">Телефон 5</label>
                                        <a v-if="phone5 && !visibility_phones['phone5'] && $hasPermission('request.phone.show_full')" class="click-to-show" @click="challengeShowPhone('phone5')"><i class="far fa-eye"></i></a>
                                        <a v-if="phone5 && visibility_phones['phone5'] && ($hasPermission('request.phone.show_full') || $hasPermission('request.phone.show_full.without_challenge'))" class="copy-to-clipboard" @click="$copyToClipboard(phone5.slice(2))"><i class="far fa-clone"></i></a>
                                        <a :href="'https://wa.me/' + phone5.slice(1)" target="_blank" v-if="phone5 && visibility_phones['phone5'] && ($hasPermission('request.phone.show_full') || $hasPermission('request.phone.show_full.without_challenge')) && showWhatsapp"><i class="fab fa-whatsapp text-success"></i></a>
                                        <PhoneField v-model="phone5" :allow_editing="true" :hide_part_phone="!visibility_phones['phone5']" @call="makeCall(phone5)" :allow_call="!request.parent_id" />
                                    </div>
                                    <div class="form-group col-sm-4 col-xl-4">
                                        <label class="mb-1" for="phone2">Телефон 6</label>
                                        <a v-if="phone6 && !visibility_phones['phone6'] && $hasPermission('request.phone.show_full')" class="click-to-show" @click="challengeShowPhone('phone6')"><i class="far fa-eye"></i></a>
                                        <a v-if="phone6 && visibility_phones['phone6'] && ($hasPermission('request.phone.show_full') || $hasPermission('request.phone.show_full.without_challenge'))" class="copy-to-clipboard" @click="$copyToClipboard(phone6.slice(2))"><i class="far fa-clone"></i></a>
                                        <a :href="'https://wa.me/' + phone6.slice(1)" target="_blank" v-if="phone6 && visibility_phones['phone6'] && ($hasPermission('request.phone.show_full') || $hasPermission('request.phone.show_full.without_challenge')) && showWhatsapp"><i class="fab fa-whatsapp text-success"></i></a>
                                        <PhoneField v-model="phone6" :allow_editing="true" :hide_part_phone="!visibility_phones['phone6']" @call="makeCall(phone6)" :allow_call="!request.parent_id" />
                                    </div>
                                </div>
                                <div class="form-row">
                                    <div class="form-group col-sm-6 col-xl-3">
                                        <label class="mb-1" for="birthdate">Дата рождения</label>
                                        <a v-if="birthdate && birthdate.length" class="copy-to-clipboard" @click="$copyDateToClipboard(birthdate, 'DD.MM.YYYY')"><i class="far fa-clone"></i></a>
                                        <input type="date" :class="{ 'is-invalid': form.errors.has('birthdate') }" class="form-control" id="birthdate" v-model="birthdate">
                                        <has-error :form="form" field="birthdate"/>
                                    </div>
                                    <div class="form-group col-sm-6 col-xl-2">
                                        <label class="mb-1" for="age">Возраст</label>
                                        <input type="number" :class="{ 'is-invalid': form.errors.has('age') }" class="form-control" id="age" v-model="age">
                                        <has-error :form="form" field="age"/>
                                    </div>
                                </div>
                                <div class="form-row">
                                    <div class="form-group col-sm-6 col-xl-6">
                                        <label class="mb-1" for="registration_city_id">Регистрация (город)</label>
                                        <Address v-model="registration_city_id" :id="'registration_city_id'" :has-error="form.errors.has('registration_city_id')" @input="validateForm"/>
                                        <has-error :form="form" field="registration_city_id"/>
                                    </div>
                                    <div class="form-group col-sm-6 col-xl-6">
                                        <label class="mb-1" for="residence_city_id">Проживает (город)</label>
                                        <Address v-model="residence_city_id" :id="'residence_city_id'" :has-error="form.errors.has('residence_city_id')" @input="validateForm"/>
                                        <has-error :form="form" field="residence_city_id"/>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="card" v-if="$hasPermission('deals.show') && $hasPermissionInterface('request.form.deals.show')">
                            <div class="card-header">
                                <h5 class="card-title mb-0">Сделки</h5>
                            </div>
                            <div class="card-body pt-1">
                                <RequestDealsBlock :request_id="id" :platform_id="request.platform_id" />
                            </div>
                        </div>
                        <div class="card">
                            <div class="card-header">
                                <h5 class="card-title mb-0">Автомобиль <a v-if="request && request.primary_car_link" class="btn btn-primary" :href="request.primary_car_link" target="_blank" >Посмотреть <i class="fas fa-external-link-alt"></i></a></h5>
                            </div>
                            <div class="card-body pt-1">
                                <div class="form-row ">
                                    <div class="form-group col-sm-4 col-xl-3">
                                        <label class="mb-1" for="car_brand_name">Марка</label>
                                        <input type="text" class="form-control" id="car_brand_name" v-model="car_brand_name" :class="{ 'is-invalid': form.errors.has('car_brand_name') }" @focusout="validateForm">
                                        <has-error :form="form" field="car_brand_name"/>
                                    </div>
                                    <div class="form-group col-sm-4 col-xl-3">
                                        <label class="mb-1" for="car_model_name">Модель</label>
                                        <input type="text" class="form-control" id="car_model_name" v-model="car_model_name" :class="{ 'is-invalid': form.errors.has('car_model_name') }" @focusout="validateForm">
                                        <has-error :form="form" field="car_model_name"/>
                                    </div>
                                    <div class="form-group col-sm-4 col-xl-3">
                                        <label class="mb-1" for="car_modification_name">Модификация</label>
                                        <input type="text" class="form-control" id="car_modification_name" v-model="car_modification_name" :class="{ 'is-invalid': form.errors.has('car_modification_name') }">
                                        <has-error :form="form" field="car_modification_name"/>
                                    </div>
                                    <div class="form-group col-sm-4 col-xl-3">
                                        <label class="mb-1" for="car_complete_name">Комплектация</label>
                                        <input type="text" class="form-control" id="car_complete_name" v-model="car_complete_name" :class="{ 'is-invalid': form.errors.has('car_complete_name') }">
                                        <has-error :form="form" field="car_complete_name"/>
                                    </div>
                                    <div class="form-group col-sm-4 col-xl-2">
                                        <label class="mb-1" for="car_year">Год</label>
                                        <input type="number" class="form-control" id="car_year" v-model="car_year" :class="{ 'is-invalid': form.errors.has('car_year') }">
                                        <has-error :form="form" field="car_year"/>
                                    </div>
                                    <div class="form-group col-sm-4 col-xl-2">
                                        <label class="mb-1" for="car_color">Цвет</label>
                                        <input type="text" class="form-control" id="car_color" v-model="car_color" :class="{ 'is-invalid': form.errors.has('car_color') }">
                                        <has-error :form="form" field="car_color"/>
                                    </div>
                                    <div class="form-group col-sm-6 col-xl-2">
                                        <label class="mb-1" for="car_cost">Стоимость</label>
                                        <input type="number" class="form-control" id="car_cost" v-model="car_cost" :class="{ 'is-invalid': form.errors.has('car_cost') }">
                                        <has-error :form="form" field="car_cost"/>
                                    </div>
                                    <div class="form-group col-sm-6 col-xl-6">
                                        <div class="row pr-1 pl-1">
                                            <div class="col-6">
                                                <div class="custom-controls-stacked">
                                                    <label class="custom-control custom-radio custom-control-inline mb-2">
                                                        <input name="car_condition" type="radio" class="custom-control-input" value="new" v-model="car_condition" :class="{ 'is-invalid': form.errors.has('car_condition') }" @change="validateForm">
                                                        <span class="custom-control-label">Новый</span>
                                                    </label>
                                                    <label class="custom-control custom-radio custom-control-inline">
                                                        <input name="car_condition" type="radio" class="custom-control-input" value="used" v-model="car_condition" :class="{ 'is-invalid': form.errors.has('car_condition') }" @change="validateForm">
                                                        <span class="custom-control-label">Подержанный</span>
                                                    </label>
                                                </div>
                                            </div>
                                            <div class="col-6">
                                                <checkbox v-model="is_trade_in" :id="'is_trade_in'" :class="'custom-control-inline mb-2'">Trade-In</checkbox>
                                                <checkbox v-model="is_utilisation" :id="'is_utilisation'" :class="'custom-control-inline'">Утилизация</checkbox>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="card">
                            <div class="card-header">
                                <h5 class="card-title mb-0">Кредит</h5>
                            </div>
                            <div class="card-body pt-1">
                                <div class="form-row ">
                                    <div class="form-group col-sm-6 col-xl-3">
                                        <label class="mb-1" for="credit_initial_payment">Первоначальный взнос</label>
                                        <input type="number" max="9999999" class="form-control" id="credit_initial_payment" v-model="credit_initial_payment" :class="{ 'is-invalid': form.errors.has('credit_initial_payment') }">
                                        <has-error :form="form" field="credit_initial_payment"/>
                                    </div>
                                    <div class="form-group col-sm-6 col-xl-3">
                                        <label class="mb-1" for="credit_term">Срок кредита</label>
                                        <input type="number" max="240" class="form-control" id="credit_term" v-model="credit_term" :class="{ 'is-invalid': form.errors.has('credit_term') }">
                                        <has-error :form="form" field="credit_term"/>
                                    </div>
                                    <div class="form-group col-sm-6 col-xl-3">
                                        <label class="mb-1" :for="'bank_decision' + _uid">Решение банка</label>
                                        <Select2 v-model="bank_decision" :options="bank_decision_select" :id="'bank_decision' + _uid" :settings="{width: '100%'}" :class="{ 'has-error': form.errors.has('bank_decision') }" :disabled="!$hasRole('admin')" @select="validateForm"/>
                                        <has-error :form="form" field="bank_decision"/>
                                    </div>
                                    <div class="form-group col-sm-6 col-xl-3 d-flex justify-content-center align-items-center">
<!--                                        <label class="mb-1" for="credit_term">Скоринг</label>-->
                                        <CreditScoreIcon :score="request.credit_score"/>
                                    </div>
                                </div>
                                <CreditRequestsBlock v-if="showCreditRequestsBlock" :request="request" :managers_select="credit_managers_select"/>
                            </div>
                        </div>

                        <div class="card" v-if="$hasPermission('requests.fssp_productions.show')">
                            <div class="card-header">
                                <h5 class="card-title mb-0">ФССП</h5>
                            </div>
                            <div class="card-body pt-1">
                                <RequestFsspBlock :request_id="id" />
                            </div>
                        </div>

                        <div class="card" v-if="(!$hasRole('sales_manager') && !$hasRole('credit_manager'))">
                            <div class="card-header">
                                <h5 class="card-title mb-0">Данные от источника</h5>
                            </div>
                            <div class="card-body pt-1">
                                <table class="table table-sm table-">
                                    <tr><td>ip: </td><td>{{request.ip}} <span class="text-muted" v-if="request.ip_region">({{request.ip_region.name}})</span></td></tr>
                                    <tr><td>referer: </td><td><div v-if="request.referer"><a :href="request.referer" target="_blank">{{request.referer.slice(0, 75)}} <span v-if="request.referer.length >= 75">...</span></a></div></td></tr>
                                    <tr><td>utm_source: </td><td>{{request.utm_source}}</td></tr>
                                    <tr><td>utm_medium: </td><td>{{request.utm_medium}}</td></tr>
                                    <tr><td>utm_campaign: </td><td>{{request.utm_campaign}}</td></tr>
                                    <tr><td>utm_term: </td><td>{{request.utm_term}}</td></tr>
                                    <tr><td>utm_content: </td><td>{{request.utm_content}}</td></tr>
                                    <tr><td>yclid: </td><td>{{request.yclid}}</td></tr>
                                </table>
                            </div>
                        </div>

                        <div style="margin-bottom: 6rem">
                            <div v-if="$hasPermission('requests.edit') && !request.parent_id && !isNeedTakeToWorkForSave">
                                <button :disabled="form.busy" class="btn btn-primary" @click="save">Сохранить <span class="hotkey">CTRL + S</span></button>
                                <button :disabled="form.busy" class="btn btn-gray-400 text-dark ml-2 position-relative" @click="saveAndBack">Сохранить и закрыть <span class="hotkey">CTRL + SHIFT + S</span></button>
                            </div>
                        </div>
                        <div v-if="isNeedTakeToWorkForSave" class="d-flex flex-column justify-content-start align-items-center" style="background-color: rgba(246, 249, 252, 0.5); width: 100%; height: 100%; position: absolute; top: 0px; left: 0px;">
                            <i class="fas fa-lock py-5 fa-10x"></i>
                            <span class="text-lg" style="background-color: #fff;">Чтобы начать работать с заявкой, возьмите заявку в работу!</span>
                            <button :disabled="to_work_loading" @click="getToWorkAsSalesManager" v-show="!sales_manager_id" class="btn btn-lg btn-primary mt-2" v-if="$hasRole('sales_manager')">Взять в работу как Менеджер</button>
                            <button :disabled="to_work_loading" @click="getToWorkAsCreditManager" v-show="!credit_manager_id" class="btn btn-lg btn-primary mt-2" v-if="$hasRole('credit_manager')">Взять в работу как Кредитный спец</button>
                        </div>
                    </div>
                    <div class="tab-pane fade" :id="'request-tab-2-' + _uid" role="tabpanel" v-if="$hasPermission('requests.logs.show')">
                        <div class="card">
                            <div class="card-body">
                                <RequestHistoryLogs :request_id="request.id"/>
                            </div>
                        </div>
                    </div>
                    <div class="tab-pane fade" :id="'request-tab-3-' + _uid" role="tabpanel" v-if="$hasPermission('requests.profiles.show')">
                        <div class="card">
                            <div class="card-body">
                                <ProfilesBlock :request="request"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-xl-6 px-3 pl-xl-2">
                <RequestActions v-if="!request.parent_id" :request="request"/>
                <RequestHistoryActions :request="request"/>
                <RequestChatBlock v-if="$hasPermission('requests.chats.show')" :request="request" />
                <div v-if="isNeedTakeToWorkForSave" class="d-flex flex-column justify-content-start align-items-center" style="background-color: rgba(246, 249, 252, 0.5); width: 100%; height: 100%; position: absolute; top: 0px; left: 0px;"></div>
            </div>
        </div>
        <el-dialog :visible.sync="challenge2Fa_state" width="350px" :append-to-body="true">
            <Challenge2Fa @success="handlerSuccessChallengeShowPhone" :access-to-field-name="challenge2Fa_field_name" :access-to-model="'Request'" :access-to-model-id="id" :access-to-data-type="'phone'" />
        </el-dialog>
    </div>
</template>

<script>
import axios from "axios";
import Swal from 'sweetalert2';
import RequestLoader from "../../components/loaders/RequestLoader";
import feather from "feather-icons";
import Form from "vform";
import VButton from "../../components/Button";
import Checkbox from "../../components/Checkbox";
const VueInputMask = require('vue-inputmask').default;
import Inputmask from 'inputmask';
import {PhoneOutgoingIcon} from 'vue-feather-icons';
import RequestHistoryLogs from "../../components/requests/RequestHistoryLogs";
import RequestActions from "../../components/requests/RequestActions";
import toastr from "toastr";
import RequestHistoryActions from "../../components/requests/RequestHistoryActions";
import RequestStatusData from "../../plugins/request_status_data";
import RequestCreditStatusData from "../../plugins/request_credit_status_data";
import CreditRequestsBlock from "../../components/requests/credit_requests/CreditRequestsBlock";
import ProfilesBlock from "../../components/requests/profiles/ProfilesBlock";
import ModalRequestClone from "../../components/requests/ModalRequestClone";
import RequestFsspBlock from "../../components/requests/fssp/RequestFsspBlock";
import RequestDealsBlock from "./RequestDealsBlock";
import PhoneField from "./PhoneField";
import RoleData from "../../plugins/role_data";
import CreditScoreIcon from "./CreditScoreIcon";
import {mapGetters} from "vuex";
import Address from "../others/Address";
import RequestChatBlock from "./RequestChatBlock";
import AffiliateProgramForm from "../affiliate_programs/AffiliateProgramForm.vue";
import Challenge2Fa from "../others/Challenge2Fa.vue";

export default {
    name: "RequestBlock",
    components: {
        Challenge2Fa,
        AffiliateProgramForm,
        RequestChatBlock,
        Address,
        CreditScoreIcon,
        PhoneField,
        RequestDealsBlock,
        RequestFsspBlock,
        ModalRequestClone,
        ProfilesBlock,
        CreditRequestsBlock,
        RequestHistoryActions,
        RequestActions, RequestHistoryLogs, Checkbox, VButton, RequestLoader, PhoneOutgoingIcon},
    middleware: ["auth", "requests-show"],
    props: ['id'],
    data: () => ({
        request: null,
        loading: false,

        last_name: null,
        first_name: null,
        middle_name: null,
        phone: null,
        phone2: null,
        phone3: null,
        phone4: null,
        phone5: null,
        phone6: null,
        visibility_phones: {
            phone: false,
            phone2: false,
            phone3: false,
            phone4: false,
            phone5: false,
            phone6: false,
        },
        is_trade_in: false,
        is_utilisation: false,
        in_credit_department: false,
        is_spam: false,

        phone_temp: '',
        phone2_temp: '',
        phone3_temp: '',
        phone4_temp: '',
        phone5_temp: '',
        phone6_temp: '',

        status: null,
        status_additional: null,
        status_composite: [],
        credit_status: null,
        bank_decision: null,

        operator_id: null,
        sales_manager_id: null,
        credit_manager_id: null,
        car_brand_name: null,
        car_model_name: null,
        car_modification_name: null,
        car_complete_name: null,
        car_year: null,
        car_color: null,
        car_cost: null,
        car_condition: null,
        type: null,
        birthdate: null,
        age: null,
        call_d: null,
        call_t: null,
        visit_d: null,
        visit_t: null,
        discount: null,
        credit_initial_payment: null,
        credit_term: null,
        registration_region_id: null,
        registration_city_id: null,
        residence_region_id: null,
        residence_city_id: null,

        form: new Form({
            phone: '',
        }),
        form_errors: {},

        modal_request_clone_visible: false,

        date_options: {
            firstDayOfWeek: 1,
        },

        to_work_loading: false,
        bank_decision_select: [{id: "approved", text: "Одобрен"},{id: "rejection", text: "Отказ"},{id: "limit", text: "Лимит"},],
        challenge2Fa_state: false,
        challenge2Fa_field_name: null,
    }),
    mounted() {
        let self = this;
        feather.replace();
        this.socketConnect(this.id);
        this.viewedRequest();

        this._keyListener = function(e) {
            if (e.keyCode === 83 && (e.ctrlKey)) { // CTRL + S
                e.preventDefault();
                this.save();
            }
            if (e.keyCode === 83 && e.ctrlKey && e.shiftKey) { // CTRL + SHIFT + S
                e.preventDefault();
                this.saveAndBack();
            }
        };

        document.addEventListener('keydown', this._keyListener.bind(this));
        if (this.$hasPermission('request.phone.show_full.without_challenge')) {
            this.visibility_phones = {
                phone: true,
                phone2: true,
                phone3: true,
                phone4: true,
                phone5: true,
                phone6: true,
            };
        }
    },
    beforeDestroy() {
        this.socketDisconnect(this.id);
    },
    computed: {
        visit_date() {
            if (!this.visit_d) return null;
            return this.visit_d  + " " + ( this.visit_t ? this.visit_t + ":00" : "00:00:00");
        },
        call_date() {
            if (!this.call_d) return null;
            return this.call_d  + " " + ( this.call_t ? this.call_t + ":00" : "00:00:00");
        },
        visited_at () {
            return this.request.visited_at ? moment(this.request.visited_at).format('YYYY-MM-DD HH:mm') : null
        },
        in_credit_department_datetime () {
            return this.request.in_credit_department_datetime ? moment(this.request.in_credit_department_datetime).format('YYYY-MM-DD HH:mm') : null
        },
        visited_credit_department_at () {
            return this.request.visited_credit_department_at ? moment(this.request.visited_credit_department_at).format('YYYY-MM-DD HH:mm') : null
        },
        regions: function () {
            return this.$store.getters['regions/regions'].map(function (item) {
                return {id: item.id, text: item.name};
            });
        },
        isNeedTakeToWorkForSave() {
            if (!this.$hasRole('operator')) {
                if (this.$hasRole('sales_manager') && this.request.sales_manager_id) return false;
                if (this.$hasRole('credit_manager') && this.request.credit_manager_id) return false;

                if (this.$hasRole('sales_manager') && !this.request.sales_manager_id) return true;
                if (this.$hasRole('credit_manager') && !this.request.credit_manager_id) return true;
            }
            return false;
        },
        statuses_select () {
            let self = this;
            let data = RequestStatusData.forSelect();
            let user = this.$store.getters['auth/user'];
            data = data.filter(s => {
                if (this.status === s.id) return true;
                return RoleData.hasPermissionStatus(user, 'request_status', s.id)
            });
            return data;
        },
        status_composite_select () {
            let data = RequestStatusData.forSelectComposite();
            let user = this.$store.getters['auth/user'];
            data = data.filter(s => {
                if (this.status === s.value) return true;
                return RoleData.hasPermissionStatus(user, 'request_status', s.value)
            });
            return data;
        },
        credit_statuses_select() {
            let credit_status = this.credit_status;
            let statuses = RequestCreditStatusData.forSelect();
            let user = this.$store.getters['auth/user'];
            statuses = statuses.filter(s => {
                if (this.credit_status === s.id) return true;
                return RoleData.hasPermissionStatus(user, 'request_credit_status', s.id)
            });
            return statuses;
        },
        operators_select () {
            let self = this;
            let items = [];
            this.$store.getters['operators/call_center']
                .filter(function (item) {
                    let platform_ids = [];
                    if (item.allowed_platforms) {
                        platform_ids = _.map(item.allowed_platforms, 'id');
                    }
                    return platform_ids.indexOf(self.request.platform_id) !== -1;
                })
                .forEach(function (item) {
                    if (item.is_active || (+self.operator_id === +item.id)) {
                        items.push({
                            id: item.id,
                            text: item.name,
                        });
                    }
                });
            return items;
        },
        sales_managers_select() {
            let self = this;
            let items = [];
            let users = this.$store.getters['sales_managers/all']
                .filter(function (item) {
                    let platform_ids = [];
                    if (item.allowed_platforms) {
                        platform_ids = _.map(item.allowed_platforms, 'id');
                    }
                    return platform_ids.indexOf(self.request.platform_id) !== -1;
                })
                .forEach(function (item) {
                    if (item.is_active || (+self.sales_manager_id === +item.id)) {
                        items.push({
                            id: item.id,
                            text: item.name,
                        });
                    }
                });
            if (self.request.sales_manager_id && self.request.sales_manager && !_.find(users, function(o) {return o.id === self.request.sales_manager_id;})) {
                items.push({id: self.request.sales_manager.id, text: self.request.sales_manager.name});
            }
            return items;
        },
        credit_managers_select() {
            let self = this;
            let items = [];
            let users = this.$store.getters['credit_managers/all']
                .filter(function (item) {
                    let platform_ids = [];
                    if (item.allowed_platforms) {
                        platform_ids = _.map(item.allowed_platforms, 'id');
                    }
                    return platform_ids.indexOf(self.request.platform_id) !== -1;
                })
                .forEach(function (item) {
                    if (item.is_active || (+self.credit_manager_id === +item.id)) {
                        items.push({
                            id: item.id,
                            text: item.name,
                        });
                    }
                });
            if (self.request.credit_manager_id && self.request.credit_manager && !_.find(users, function(o) {return o.id === self.request.credit_manager_id;})) {
                items.push({id: self.request.credit_manager.id, text: self.request.credit_manager.name});
            }
            return items;
        },
        canCall() {
            return this.$hasPermission('requests.call') && this.$store.getters['auth/sip_settings'].use;
        },
        ...mapGetters({
            user: 'auth/user'
        }),
        showCreditRequestsBlock() {
            if (this.user.role_names.indexOf('operator') !== -1 && this.user.role_names.length === 1) return false;
            if (this.user.role_names.indexOf('head_of_call_center') !== -1 && this.user.role_names.indexOf('operator') !== -1 && this.user.role_names.length === 2) return false;
            return true;
        },
        showWhatsapp() {
            let platform = _.find(this.$store.getters['platforms/all'], {id: this.request.platform_id})
            return platform && platform.phone_link_to_whatsapp
        }
    },
    created() {
        this.fetchData();
    },
    watch: {
        // $route: () => {},
        id: function (val, oldVal) {
            this.socketDisconnect(oldVal);
            this.socketConnect(val);
            this.fetchData();
        },
        request: function (data) {
            this.socketDisconnect(data.id);
            this.socketConnect(data.id);
            this.setData(data);
            feather.replace();
        },
        phone_temp: function (val) {let p = this.preparePhone(val);this.phone = this.validatePhone(p) ? p : null;},
        phone2_temp: function (val) {let p = this.preparePhone(val);this.phone2 = this.validatePhone(p) ? p : null;},
        phone3_temp: function (val) {let p = this.preparePhone(val);this.phone3 = this.validatePhone(p) ? p : null;},
        phone4_temp: function (val) {let p = this.preparePhone(val);this.phone4 = this.validatePhone(p) ? p : null;},
        phone5_temp: function (val) {let p = this.preparePhone(val);this.phone5 = this.validatePhone(p) ? p : null;},
        phone6_temp: function (val) {let p = this.preparePhone(val);this.phone6 = this.validatePhone(p) ? p : null;}
    },
    methods: {
        socketConnect(id) {
            let self = this;
            Echo.private(`request.${id}`)
                .listen('.request.updated_credit_status', function (e) {
                    self.credit_status = e.credit_status;
                    self.request.credit_status = e.credit_status;
                })
                .listen('.request.updated_status', function (e) {
                    self.status = e.status;
                    self.status_additional = e.status_additional;
                    self.setStatusComposite(self.status, self.status_additional)
                    self.request.status = e.status;
                    self.request.status_additional = e.status_additional;
                })
                .listen('.request.updated_bank_decision', function (e) {
                    self.bank_decision = e.bank_decision;
                    self.request.bank_decision = e.bank_decision;
                });
        },
        socketDisconnect(id) {
            Echo.leave(`request.${id}`);
        },
        setStatusComposite(status, status_additional) {
            let composite = [status];
            let statusData = RequestStatusData.getStatusDataBySlug(status);
            if (statusData && statusData.children) {
                composite.push(status_additional);
            }
            this.status_composite = composite;
        },
        async fetchData() {
            let vm = this;
            this.loading = true;
            return this.getRequest(this.id)
                .then(function (data) {
                    new Promise((resolve) => {
                        if (!vm.$isAllowRequest(data)) {
                            resolve(
                                Swal.fire({
                                    title: 'Введите полный телефон чтобы получить доступ',
                                    input: 'text',
                                    inputAttributes: {
                                        autocapitalize: 'off',
                                        id: "check-phone-access-request"
                                    },
                                    confirmButtonText: 'Получить доступ',
                                    // showLoaderOnConfirm: true,
                                    showCancelButton: true,
                                    cancelButtonText: 'Отмена',
                                    inputValidator: (value) => {
                                        let phone = vm.preparePhone(value);
                                        if (
                                            phone === null
                                            || phone === undefined
                                            || (phone !== data.phone && phone !== data.phone2 && phone !== data.phone3 && phone !== data.phone4 && phone !== data.phone5 && phone !== data.phone6)
                                        ) {
                                            return 'Неверный телефон!'
                                        }
                                    },
                                    preConfirm: (value) => {
                                        return vm.$allowRequest(data.id);
                                    },
                                    onRender(modalElement) {
                                        try {
                                            Inputmask({mask: '+7 (999) 999-99-99', clearIncomplete: true})
                                                .mask(document.getElementById('check-phone-access-request'));
                                        } catch (e) {console.log(e);}
                                    },
                                    allowOutsideClick: () => false
                                })
                            )
                        } else {
                            resolve({value: true})
                        }
                    }).then((result) => {
                        if (result.value) {
                            vm.request = data;
                            vm.loading = false;
                            vm.$bus.$emit('request:saved');
                        } else if (result.dismiss) {
                            vm.$router.back();
                        }
                    });

                    // vm.request = data;
                    // vm.loading = false;
                    // vm.$bus.$emit('request:saved');
                })
                .catch(function (error) {
                    vm.loading = false;
                    vm.$router.back();
                    if (error.response.status === 403) {
                        Swal.fire({
                            type: 'warning',
                            title: 'Доступ запрещен!',
                        })
                    } else if (error.response.status === 404) {
                        Swal.fire({
                            type: 'error',
                            title: 'Заявка не найдена!',
                        })
                    } else {
                        Swal.fire({
                            type: 'error',
                            title: 'Что-то пошло не так!',
                        })
                    }
                });
        },
        async getRequest (id) {
            return (await axios.get('/api/requests/' + this.id)).data;
        },
        setData (request) {
            this.last_name = request.last_name;
            this.first_name = request.first_name;
            this.middle_name = request.middle_name;
            this.phone = request.phone;
            this.phone2 = request.phone2;
            this.phone3 = request.phone3;
            this.phone4 = request.phone4;
            this.phone5 = request.phone5;
            this.phone6 = request.phone6;
            this.phone_temp = request.phone ? request.phone : '';
            this.phone2_temp = request.phone2 ? request.phone2 : '';
            this.phone3_temp = request.phone3 ? request.phone3 : '';
            this.phone4_temp = request.phone4 ? request.phone4 : '';
            this.phone5_temp = request.phone5 ? request.phone5 : '';
            this.phone6_temp = request.phone6 ? request.phone6 : '';
            this.is_trade_in = !!request.is_trade_in;
            this.is_utilisation = !!request.is_utilisation;
            this.in_credit_department = !!request.in_credit_department;
            this.is_spam = !!request.is_spam;
            this.status = request.status;
            this.status_additional = request.status_additional;
            this.setStatusComposite(this.status, this.status_additional);
            this.credit_status = request.credit_status;
            this.bank_decision = request.bank_decision;
            this.operator_id = request.operator_id;
            this.sales_manager_id = request.sales_manager_id;
            this.credit_manager_id = request.credit_manager_id;
            this.car_brand_name = request.car_brand_name;
            this.car_model_name = request.car_model_name;
            this.car_modification_name = request.car_modification_name;
            this.car_complete_name = request.car_complete_name;
            this.car_year = request.car_year;
            this.car_color = request.car_color;
            this.car_cost = request.car_cost;
            this.car_condition = request.car_condition;
            this.type = request.type;
            this.birthdate = request.birthdate;
            this.age = request.age;
            if (request.visit_date) {
                let visit_date = moment(request.visit_date);
                this.visit_d = visit_date.format('YYYY-MM-DD');
                this.visit_t = visit_date.format('HH:mm') === '00:00' ? null : visit_date.format('HH:mm');
            } else {
                this.visit_d = null;
                this.visit_t = null;
            }
            if (request.call_date) {
                let call_date = moment(request.call_date);
                this.call_d = call_date.format('YYYY-MM-DD');
                this.call_t = call_date.format('HH:mm') === '00:00' ? null : call_date.format('HH:mm');
            } else {
                this.call_d = null;
                this.call_t = null;
            }
            this.discount = request.discount;
            this.credit_initial_payment = request.credit_initial_payment;
            this.credit_term = request.credit_term;
            this.registration_region_id = request.registration_region_id;
            this.registration_city_id = request.registration_city_id;
            this.residence_region_id = request.residence_region_id;
            this.residence_city_id = request.residence_city_id;
        },
        preparePhone (p) {
            return p.replace(/[^\+0-9]/g, '');
        },
        validatePhone (p) {
            return p.slice(0,2) === '+7' && p.length === 12;
        },
        checkTempPhone () {if (!this.validatePhone(this.preparePhone(this.phone_temp))) this.phone_temp = '';},
        checkTempPhone2 () {if (!this.validatePhone(this.preparePhone(this.phone2_temp))) this.phone2_temp = '';},
        checkTempPhone3 () {if (!this.validatePhone(this.preparePhone(this.phone3_temp))) this.phone3_temp = '';},
        checkTempPhone4 () {if (!this.validatePhone(this.preparePhone(this.phone4_temp))) this.phone4_temp = '';},
        checkTempPhone5 () {if (!this.validatePhone(this.preparePhone(this.phone5_temp))) this.phone5_temp = '';},
        checkTempPhone6 () {if (!this.validatePhone(this.preparePhone(this.phone6_temp))) this.phone6_temp = '';},
        async save(fetch = true) {
            let self = this;
            if (this.validateForm()) {
                self.scrollToTop();
                await this.form.put('/api/requests/' + this.request.id);
                toastr.success('Сохранено');
                if (fetch) self.fetchData();
                return true;
            } else {
                toastr.error('Ошибка, проверьте поля!');
                return false;
            }
        },
        async saveAndBack() {
            if (window.history.length > 1){
                let res = await this.save(false);
                if (res) this.$router.go(-1);
            } else {
                await this.save(true);
            }
        },
        validateForm() {
            this.form = new Form();

            let data_save = {};

            data_save.last_name = this.last_name ? this.last_name : null;
            data_save.first_name = this.first_name ? this.first_name : null;
            data_save.middle_name = this.middle_name ? this.middle_name : null;

            if (!this.phone) {
                this.form.errors.set('phone', ['Основной телефон не может быть пустым']);
            } else {
                data_save.phone = this.phone;
            }
            if (_.findIndex(this.statuses_select, ['id', this.status]) === -1) {
                this.form.errors.set('status');
            }
            if (this.status === 'not_answer') {
                if (!this.call_date) this.form.errors.set('call_date');
            }
            if (this.status === 'arrived' || this.status === 'not_marked_in_salon' || this.status === 'bought') {
                if (!this.type || !this.type.length) this.form.errors.set('type');
                if (!this.first_name || !this.first_name.length) this.form.errors.set('first_name');
                if (!this.car_brand_name || !this.car_brand_name.length) this.form.errors.set('car_brand_name');
                if (!this.car_model_name || !this.car_model_name.length) this.form.errors.set('car_model_name');
                if (!this.car_condition || !this.car_condition.length) this.form.errors.set('car_condition');
                // if (!this.residence_region_id) this.form.errors.set('residence_region_id');
                if (!this.residence_city_id) this.form.errors.set('residence_city_id');
            }
            if (this.status === 'will_arrive') {
                if (!this.call_date) this.form.errors.set('call_date');
                if (!this.visit_date) this.form.errors.set('visit_date');
                if (!this.type || !this.type.length) this.form.errors.set('type');
                if (!this.first_name || !this.first_name.length) this.form.errors.set('first_name');
                if (!this.car_brand_name || !this.car_brand_name.length) this.form.errors.set('car_brand_name');
                if (!this.car_model_name || !this.car_model_name.length) this.form.errors.set('car_model_name');
                if (!this.car_condition || !this.car_condition.length) this.form.errors.set('car_condition');
                // if (!this.residence_region_id) this.form.errors.set('residence_region_id');
                if (!this.residence_city_id) this.form.errors.set('residence_city_id');
            }

            data_save.phone2 = this.phone2 ? this.phone2 : null;
            data_save.phone3 = this.phone3 ? this.phone3 : null;
            data_save.phone4 = this.phone4 ? this.phone4 : null;
            data_save.phone5 = this.phone5 ? this.phone5 : null;
            data_save.phone6 = this.phone6 ? this.phone6 : null;
            data_save.is_trade_in = this.is_trade_in;
            data_save.is_utilisation = this.is_utilisation;
            data_save.in_credit_department = this.in_credit_department;
            data_save.is_spam = this.is_spam;
            data_save.status = this.status;
            data_save.status_additional = this.status_additional;
            data_save.credit_status = this.credit_status;
            if (this.$hasRole('admin')) data_save.bank_decision = this.bank_decision;
            data_save.operator_id = this.operator_id;
            data_save.sales_manager_id = this.sales_manager_id;
            data_save.credit_manager_id = this.credit_manager_id;
            data_save.car_brand_name = this.car_brand_name;
            data_save.car_model_name = this.car_model_name;
            data_save.car_modification_name = this.car_modification_name;
            data_save.car_complete_name = this.car_complete_name;
            data_save.car_year = this.car_year;
            data_save.car_color = this.car_color;
            data_save.car_cost = this.car_cost;
            data_save.car_condition = this.car_condition;
            data_save.type = this.type;
            data_save.birthdate = this.birthdate;
            data_save.age = this.age;
            data_save.call_date = this.call_date;
            data_save.visit_date = this.visit_date;
            data_save.discount = this.discount;
            data_save.credit_initial_payment = this.credit_initial_payment;
            data_save.credit_term = this.credit_term;
            data_save.registration_region_id = this.registration_region_id;
            data_save.registration_city_id = this.registration_city_id;
            data_save.residence_region_id = this.residence_region_id;
            data_save.residence_city_id = this.residence_city_id;

            data_save.only_fields = [];
            if (data_save.last_name !== this.request.last_name) data_save.only_fields.push('last_name');
            if (data_save.first_name !== this.request.first_name) data_save.only_fields.push('first_name');
            if (data_save.middle_name !== this.request.middle_name) data_save.only_fields.push('middle_name');
            if (data_save.phone !== this.request.phone) data_save.only_fields.push('phone');
            if (data_save.phone2 !== this.request.phone2) data_save.only_fields.push('phone2');
            if (data_save.phone3 !== this.request.phone3) data_save.only_fields.push('phone3');
            if (data_save.phone4 !== this.request.phone4) data_save.only_fields.push('phone4');
            if (data_save.phone5 !== this.request.phone5) data_save.only_fields.push('phone5');
            if (data_save.phone6 !== this.request.phone6) data_save.only_fields.push('phone6');
            if (data_save.is_trade_in !== this.request.is_trade_in) data_save.only_fields.push('is_trade_in');
            if (data_save.is_utilisation !== this.request.is_utilisation) data_save.only_fields.push('is_utilisation');
            if (data_save.in_credit_department !== this.request.in_credit_department) data_save.only_fields.push('in_credit_department');
            if (data_save.is_spam !== this.request.is_spam) data_save.only_fields.push('is_spam');
            if (data_save.status !== this.request.status) data_save.only_fields.push('status');
            if (data_save.status_additional !== this.request.status_additional) data_save.only_fields.push('status_additional');
            if (data_save.credit_status !== this.request.credit_status) data_save.only_fields.push('credit_status');
            if (data_save.bank_decision !== this.request.bank_decision && this.$hasRole('admin')) data_save.only_fields.push('bank_decision');
            if (data_save.operator_id !== this.request.operator_id) data_save.only_fields.push('operator_id');
            if (data_save.sales_manager_id !== this.request.sales_manager_id) data_save.only_fields.push('sales_manager_id');
            if (data_save.credit_manager_id !== this.request.credit_manager_id) data_save.only_fields.push('credit_manager_id');
            if (data_save.car_brand_name !== this.request.car_brand_name) data_save.only_fields.push('car_brand_name');
            if (data_save.car_model_name !== this.request.car_model_name) data_save.only_fields.push('car_model_name');
            if (data_save.car_modification_name !== this.request.car_modification_name) data_save.only_fields.push('car_modification_name');
            if (data_save.car_complete_name !== this.request.car_complete_name) data_save.only_fields.push('car_complete_name');
            if (data_save.car_year !== this.request.car_year) data_save.only_fields.push('car_year');
            if (data_save.car_color !== this.request.car_color) data_save.only_fields.push('car_color');
            if (data_save.car_cost !== this.request.car_cost) data_save.only_fields.push('car_cost');
            if (data_save.car_condition !== this.request.car_condition) data_save.only_fields.push('car_condition');
            if (data_save.type !== this.request.type) data_save.only_fields.push('type');
            if (data_save.birthdate !== this.request.birthdate) data_save.only_fields.push('birthdate');
            if (data_save.age !== this.request.age) data_save.only_fields.push('age');
            if (data_save.call_date !== this.request.call_date) data_save.only_fields.push('call_date');
            if (data_save.visit_date !== this.request.visit_date) data_save.only_fields.push('visit_date');
            if (data_save.discount !== this.request.discount) data_save.only_fields.push('discount');
            if (data_save.credit_initial_payment !== this.request.credit_initial_payment) data_save.only_fields.push('credit_initial_payment');
            if (data_save.credit_term !== this.request.credit_term) data_save.only_fields.push('credit_term');
            if (data_save.registration_region_id !== this.request.registration_region_id) data_save.only_fields.push('registration_region_id');
            if (data_save.registration_city_id !== this.request.registration_city_id) data_save.only_fields.push('registration_city_id');
            if (data_save.residence_region_id !== this.request.residence_region_id) data_save.only_fields.push('residence_region_id');
            if (data_save.residence_city_id !== this.request.residence_city_id) data_save.only_fields.push('residence_city_id');

            if (this.form.errors.any()) {
                return false;
            } else {
                this.form = new Form(data_save);
                return true;
            }
        },
        async getToWork () {
            if (this.validateForm()) {
                this.to_work_loading = true;
                try {
                    await axios.post('/api/requests/' + this.id + '/take_to_work', {as: "operator",});
                    this.fetchData();
                } catch (e) {
                    this.to_work_loading = false;
                }
                this.to_work_loading = false;
            } else {
                toastr.error('Сначала заполните необходимые поля!');
            }
        },
        async getToWorkAsSalesManager () {
            this.to_work_loading = true;
            try {
                await axios.post('/api/requests/' + this.id + '/take_to_work', {as: "sales_manager",});
                this.request = await this.getRequest(this.id);
                await this.setData(this.request);

                this.call_d = null;
                this.call_t = null;
                // this.status = 'arrived'; // Статус изменяется на бэке
                await this.save();
            } catch (e) {
                this.to_work_loading = false;
            }
            this.to_work_loading = false;
        },
        async getToWorkAsCreditManager () {
            this.to_work_loading = true;
            try {
                await axios.post('/api/requests/' + this.id + '/take_to_work', {as: "credit_manager",});
                this.request = await this.getRequest(this.id);
                await this.setData(this.request);

                this.credit_status = 'in_work';
                await this.save();
            } catch (e) {
                this.to_work_loading = false;
            }
            this.to_work_loading = false;
        },

        makeCall(phone) {
            this.$bus.$emit('make-call', {phone: phone, request_id: this.id});
        },
        viewedRequest() {
            axios.post('/api/requests/' + this.id + '/viewedRequest');
        },
        handleChangeStatusComposite(value) {
            this.status = value[0];
            this.status_additional = value[1] ? value[1] : null;
            this.validateForm();
        },
        challengeShowPhone(filed) {
            this.challenge2Fa_state = true;
            this.challenge2Fa_field_name = filed;
        },
        handlerSuccessChallengeShowPhone(data) {
            this.visibility_phones[data.accessToFieldName] = true;
            this.challenge2Fa_state = false;
        },
        scrollToTop() {
            window.scrollTo({
                top: 0,
                left: 0,
                behavior: 'smooth'
            })
        }
    }
}
</script>

<style scoped>
.hotkey {
    font-size: 60%;
    background-color: #99999999;
    padding: 0 3px;
    border-radius: 2px;
    color: white;
}
/*input.amber-border {*/
/*    border-top: 0;*/
/*    border-right: 0;*/
/*    border-left: 0;*/
/*    border-radius: 0;*/
/*    border-bottom-color: #E3E4E6;*/
/*}*/
/*input.amber-border::placeholder {*/
/*    color: #E3E4E6;*/
/*    opacity: 1;*/
/*}*/
</style>
